export function FolderIcon({ width = 32 }: { width?: number }) {
  return (
    <svg
      aria-hidden="true"
      width={width}
      height="32"
      viewBox="0 0 32 32"
      fill="#377771"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M13.4 5H5.6C4.17 5 3.013 6.18125 3.013 7.625L3 23.375C3 24.8188 4.17 26 5.6 26H26.4C27.83 26 29 24.8188 29 23.375V10.25C29 8.80625 27.83 7.625 26.4 7.625H16L13.4 5Z" />
      <path
        d="M13.4 5H5.6C4.17 5 3.013 6.18125 3.013 7.625L3 23.375C3 24.8188 4.17 26 5.6 26H26.4C27.83 26 29 24.8188 29 23.375V10.25C29 8.80625 27.83 7.625 26.4 7.625H16L13.4 5Z"
        fill="black"
        fillOpacity="0.25"
      />
      <path d="M27 26H5.00001C3.89544 26 3.00001 25.1046 3.00001 24V12.1774L3 12.1628C3.00028 12.0006 3.03432 9.00043 5.16667 9.00013C7.23336 8.99985 25.3124 9.0001 27.3659 9.00013C27.4972 9.00013 27.6212 9.01152 27.7418 9.06348C28.1321 9.23164 29 9.80646 29 11.5932V24.0025C29 25.1071 28.1046 26 27 26Z" />
    </svg>
  );
}
